// JoinZoom.js
import React, { useState } from "react";
import SidePanel from "../../Components/SidePanel";
import ReactHelmet from "../../Components/ReactHelmet";
import Styles from "./ZoomApp.module.css";
import TopBar from "../../Components/TopBar";
import RightSidePanel from "../../Components/RightSidePanel";
import { useLocation } from "react-router-dom";

const ZoomError = () => {
  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const [OpenMenuBar2, setOpenMenuBar2] = useState(false);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const error = query.get("e");
  const Mobile_Screen = window.innerWidth;

  return (
    <div className={Styles.Dashboard}>
      <ReactHelmet title={"Zoom"} description={"Zoom Link"} />
      {/* SidePanel */}

      {Mobile_Screen >= 780 ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          SetSideBarOpen2={setOpenMenuBar2}
          SidebarOpen2={OpenMenuBar2}
          Page="Zoom"
        />
      ) : (
        ""
      )}

      {Mobile_Screen <= 480 && SidebarOpen ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Zoom Class"
        />
      ) : (
        ""
      )}
      <section className={Styles.MiddleSection}>
        <div style={{ marginTop: "30px" }}>
          <TopBar
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            SetSideBarOpen2={setOpenMenuBar2}
            SidebarOpen2={OpenMenuBar2}
            PageName={"Zoom Class"}
          />
        </div>

        {error ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <div
              style={{
                border: "1px solid #ccc",
                padding: "20px",
                borderRadius: "8px",
                width: "350px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <h3 style={{ color: "red" }}>Something went wrong !</h3>
              <p>{error}</p>
            </div>

            <div style={{ marginTop: "20px" }}>
              <a
                href="/dashboard"
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  textDecoration: "none",
                  display: "inline-block",
                }}
              >
                Go to Dashboard
              </a>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <div
              style={{
                border: "1px solid #ccc",
                padding: "20px",
                borderRadius: "8px",
                width: "300px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <h3 style={{ color: "black" }}>No Error found !</h3>
            </div>
            <div style={{ marginTop: "20px" }}>
              <a
                href="/dashboard"
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  textDecoration: "none",
                  display: "inline-block",
                }}
              >
                Go to Dashboard
              </a>
            </div>
          </div>
        )}
      </section>

      <RightSidePanel
        SetSideBarOpen={setOpenMenuBar2}
        SidebarOpen={OpenMenuBar2}
      />

      <div
        onClick={() => {
          SetSideBarOpen(false);
          setOpenMenuBar2(false);
        }}
        className={SidebarOpen || OpenMenuBar2 ? "overlay active" : "overlay"}
        id="overlay"
      ></div>
    </div>
  );
};

export default ZoomError;
